import React from 'react';
import Notification from '../Notification';
import './style.scss';

const Notifications = ({
  notifications,
  // setPage,
  // setPageSize,
  markRead,
  dismiss,
}) => {

  return (
    <div className="notification-center__tab notification-center__tab--all-notification">
      <div className="notification-menu-notifications">
        {
          notifications.map((item) => {
            const { id } = item;

            return (
              <Notification
                key={id}
                notification={item}
                myFocus={false}
                markRead={markRead}
                dismiss={dismiss}
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default Notifications;
